import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {withGoogleMap, GoogleMap, Marker, Circle} from 'react-google-maps';
import withScriptjs from 'react-google-maps/lib/async/withScriptjs';

import {ContactPageContentWrapperStyled, MapContainerStyled} from './ContactPage.style';
import {H4, PhoneNumber} from '../../styles/components/typography.style';
import {Hr1Styled, Hr2Styled} from '../../styles/components/hr.style';
import OpeningTimes from './OpeningTimes';
import Loading from '../../components/Loading/Loading';
import config from '../../config';
import FacebookLike from '../../components/FacebookLike/FacebookLike';
import ExceptionalTimes from '../../components/ExceptionalTimes/ExceptionalTimes';

const ContactPageContent = ({restaurant}) => {
  const telephoneToUrl = `tel:${restaurant.contactNumber}`;
  const Map = withScriptjs(
    withGoogleMap(
      props => (
        <GoogleMap
          ref={props.onMapLoad}
          defaultZoom={props.zoom}
          defaultCenter={{lat: restaurant.coordinates.latitude, lng: restaurant.coordinates.longitude}}
        >
          {props.marker && <Marker {...props.marker} />}
          {props.circle && <Circle {...props.circle} />}
        </GoogleMap>
      )
    )
  );

  const mapMarker = restaurant.coordinates && restaurant.coordinates.latitude && restaurant.coordinates.longitude &&
    <Map
      googleMapURL={config.googleMapURL}
      loadingElement={
        <MapContainerStyled>
          <Loading isLight={true} />
        </MapContainerStyled>
      }
      containerElement={<MapContainerStyled />}
      mapElement={<div style={{height: '100%'}} />}
      marker={{position: {lat: restaurant.coordinates.latitude, lng: restaurant.coordinates.longitude}}}
      zoom={15}
    />;

  const mapRadius = restaurant.coordinates && restaurant.coordinates.latitude && restaurant.coordinates.longitude &&
    <Map
      googleMapURL={config.googleMapURL}
      loadingElement={
        <MapContainerStyled>
          <Loading isLight={true} />
        </MapContainerStyled>
      }
      containerElement={<MapContainerStyled />}
      mapElement={<div style={{height: '100%'}} />}
      circle={{
        center: {lat: restaurant.coordinates.latitude, lng: restaurant.coordinates.longitude},
        radius: restaurant.deliverySettings.distanceRadiusInMetres || 3000,
        options: {
          fillColor: 'red',
          fillOpacity: 0.20,
          strokeColor: 'red',
          strokeOpacity: 1,
          strokeWeight: 2
        }
      }}
      zoom={10}
    />;

  const googleMapsUrl = (restaurant.thirdPartyServices && restaurant.thirdPartyServices.googleMapsUrl) ||
    `https://www.google.co.uk/maps/place/${restaurant.address.singleLine}`;
  const singleLineAddress = restaurant.address.singleLine &&
    <p>
      <span data-rw="contact-page--restaurant-address">{restaurant.address.singleLine}</span><br />
      <a
        href={googleMapsUrl}
        target="_blank"
        data-rw="contact-page--open-map-link"
      >
        <FormattedMessage id="contact.openInGoogleMaps" />
      </a>
    </p>;

  const renderCollectionTimes = restaurant.modes && !!restaurant.modes.collection &&
    <div>
      <H4 data-rw="contact-page--collection-hours"><FormattedMessage id="contact.pickupHours" /></H4>
      <OpeningTimes
        openingTimes={restaurant.collectionTimes}
        restaurantModes={restaurant.modes}
      />
    </div>;

  const renderDeliveryTimes = restaurant.modes && !!restaurant.modes.delivery &&
    <div>
      <H4 data-rw="contact-page--delivery-hours"><FormattedMessage id="contact.deliveryHours" /></H4>
      <OpeningTimes openingTimes={restaurant.deliveryTimes} />
      <Hr1Styled />
      <H4><FormattedMessage id="contact.deliveryArea" /></H4>
      <small><FormattedMessage id="contact.deliveryAreaNote" /></small>
      {mapRadius}
    </div>;

  const renderExceptionalClosingTimes = restaurant.exceptionalClosingTimes && restaurant.exceptionalClosingTimes.length > 0 &&
    <ExceptionalTimes
      restaurant={restaurant}
      opening={false}
    />;

  const renderExceptionalOpeningTimes = restaurant.exceptionalOpeningTimes && restaurant.exceptionalOpeningTimes.length > 0 &&
    <ExceptionalTimes
      restaurant={restaurant}
      opening={true}
    />;

  return (
    <div>
      <ContactPageContentWrapperStyled data-rw="contact-page--content">
        <div data-rw="contact-page--delivery-info"
          dangerouslySetInnerHTML={{__html: restaurant.content.contactUs}} // eslint-disable-line react/no-danger
        />
        <H4><FormattedMessage id="contact.address" /></H4>
        {singleLineAddress}
        {mapMarker}
        <H4><FormattedMessage id="contact.contactDetails" /></H4>
        <p>
          <FormattedMessage id="contact.tel" />:
          <PhoneNumber
            href={telephoneToUrl}
            data-rw="contact-page--phone-number"
          >
            {restaurant.contactNumber}
          </PhoneNumber>
        </p>
        <Hr1Styled />
        {renderExceptionalClosingTimes}
        {renderExceptionalOpeningTimes}
        {renderCollectionTimes}
        {renderDeliveryTimes}
        {
          restaurant.thirdPartyServices && restaurant.thirdPartyServices.facebookPageUrl &&
          <Hr2Styled />
        }
      </ContactPageContentWrapperStyled>
      {/* TODO refactor ContactPageContentWrapperStyled same as HomePageContent -> Wrapper -> Container to remove wrapper div from here */}
      {
        restaurant.thirdPartyServices && restaurant.thirdPartyServices.facebookPageUrl &&
        <FacebookLike
          pageContext="contactPage"
          url={restaurant.thirdPartyServices.facebookPageUrl}
        />
      }
    </div>
  );
};

ContactPageContent.propTypes = {
  restaurant: PropTypes.object.isRequired,
  circle: PropTypes.object
};

export default ContactPageContent;



// WEBPACK FOOTER //
// ./containers/ContactPage/ContactPageContent.js